<template>
  <v-row>
    <v-col cols="12" v-text="$route.name" class="mt-5 grey--text text-h2" />
    <v-col cols="12" class="px-0">
      <v-col class="mt-5" cols="12">
        <CPTInput
          v-model="enrollment"
          autofocus
          counter="11"
          label="Matrícula*"
          type="number"
          v-maska="'###########'"
          @keydown.enter="isValidEnrollment && getInscricao()"
        />
      </v-col>
      <v-col cols="12 d-flex justify-end">
        <CPTBtn
          :disabled="!isValidEnrollment"
          icon="mdi-printer"
          label="Imprimir"
          @click="getInscricao()"
        />
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import CPTInput from "@/components/Input";
import CPTBtn from "@/components/Btn";

export default {
  name: "busca-encaminhamento-plantao",

  components: {
    CPTInput,
    CPTBtn
  },

  data: () => ({
    enrollment: null
  }),

  computed: {
    isValidEnrollment() {
      return this.enrollment?.length === 11;
    }
  },

  methods: {
    getInscricao() {
      this.$http
        .get(`matricula/${this.enrollment}/inscricao-plantao`)
        .then(inscricao => {
          if (!inscricao)
            return this.showMessage(
              "Não existe inscrição para essa matrícula",
              "error"
            );

          if (inscricao.status != "DEFERIDO")
            return this.showMessage(
              "Essa inscrição ainda não foi deferida",
              "warning"
            );

          this.$router.push(`/encaminhamento-plantao/${inscricao.id}`);
        })
        .catch(error => this.showMessage(error, "error"));
    }
  }
};
</script>
